import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './components/shared/Toast';
import EmbedBridge from './components/shared/EmbedBridge';
import LoginPage from './components/auth/LoginPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/shared/Layout';
import PartnerDashboard from './components/partner/PartnerDashboard';
import PartnerProfile from './components/partner/PartnerProfile';
import AssetGenerator from './components/partner/AssetGenerator';
import AssetHistory from './components/partner/AssetHistory';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminPartners from './components/admin/AdminPartners';
import AdminTopics from './components/admin/AdminTopics';
import AdminLibrary from './components/admin/AdminLibrary';
import AdminLimits from './components/admin/AdminLimits';
import AdminSettings from './components/admin/AdminSettings';
import AdminUsers from './components/admin/AdminUsers';
import AdminSkills from './components/admin/AdminSkills';
import MarketingDashboard from './components/marketing/MarketingDashboard';
import MarketingStudio from './components/marketing/MarketingStudio';
import MarketingVideos from './components/marketing/MarketingVideos';
import SalesDashboard from './components/sales/SalesDashboard';
import SalesAssetGenerator from './components/sales/SalesAssetGenerator';
import SalesAssetHistory from './components/sales/SalesAssetHistory';
import CustomerPanel from './components/panel/CustomerPanel';
import PMDashboard from './components/pm/PMDashboard';
import PMPartners from './components/pm/PMPartners';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <EmbedBridge />
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            {/* Partner routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute requiredRole="partner">
                <Layout><PartnerDashboard /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute requiredRole="partner">
                <Layout><PartnerProfile /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/generate" element={
              <ProtectedRoute requiredRole="partner">
                <Layout><AssetGenerator /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/history" element={
              <ProtectedRoute requiredRole="partner">
                <Layout><AssetHistory /></Layout>
              </ProtectedRoute>
            } />

            {/* Admin routes */}
            <Route path="/admin" element={
              <ProtectedRoute requiredRole="admin">
                <Layout><AdminDashboard /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/partners" element={
              <ProtectedRoute requiredRole="admin">
                <Layout><AdminPartners /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/topics" element={
              <ProtectedRoute requiredRole="admin">
                <Layout><AdminTopics /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/library" element={
              <ProtectedRoute requiredRole="admin">
                <Layout><AdminLibrary /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/limits" element={
              <ProtectedRoute requiredRole="admin">
                <Layout><AdminLimits /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/settings" element={
              <ProtectedRoute requiredRole="admin">
                <Layout><AdminSettings /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute requiredRole="admin">
                <Layout><AdminUsers /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/admin/skills" element={
              <ProtectedRoute requiredRole="admin">
                <Layout><AdminSkills /></Layout>
              </ProtectedRoute>
            } />

            {/* Internal Marketing routes */}
            <Route path="/marketing" element={
              <ProtectedRoute requiredRole="marketing">
                <Layout><MarketingDashboard /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/marketing/studio" element={
              <ProtectedRoute requiredRole="marketing">
                <Layout><MarketingStudio /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/marketing/videos" element={
              <ProtectedRoute requiredRole="marketing">
                <Layout><MarketingVideos /></Layout>
              </ProtectedRoute>
            } />

            {/* Sales routes */}
            <Route path="/sales" element={
              <ProtectedRoute requiredRole="sales">
                <Layout><SalesDashboard /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/sales/generate" element={
              <ProtectedRoute requiredRole="sales">
                <Layout><SalesAssetGenerator /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/sales/history" element={
              <ProtectedRoute requiredRole="sales">
                <Layout><SalesAssetHistory /></Layout>
              </ProtectedRoute>
            } />

            {/* Partner Manager routes */}
            <Route path="/pm" element={
              <ProtectedRoute requiredRole="partner_manager">
                <Layout><PMDashboard /></Layout>
              </ProtectedRoute>
            } />
            <Route path="/pm/partners" element={
              <ProtectedRoute requiredRole="partner_manager">
                <Layout><PMPartners /></Layout>
              </ProtectedRoute>
            } />

            {/* Public customer panel */}
            <Route path="/panel/:token" element={<CustomerPanel />} />

            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
